import React from "react";
import MapTo from "../../utils/mapto";
import styled from "styled-components";
import { navigate } from "gatsby";

const StyledContainer = styled.div`
    background: ${props => props.backgroundColor || 'transparent'};
    box-shadow: ${props => props.backgroundShadow || 'none'};
    cursor: ${props => props.isClickable ? 'pointer' : 'default'};
    transition: transform 0.2s ease-in-out;
    &:hover {
        transform: ${props => props.isClickable ? 'translateY(-4px)' : 'none'};
    }
`;

const Card4 = (props) => {
    const items = props?.items || props?.content?.items;
    const backgroundColor = props?.backgroundColor?.trim() || (props.content && props?.content.backgroundColor?.trim());
    const backgroundShadow = props?.backgroundShadow?.trim() || (props.content && props?.content.backgroundShadow?.trim());
    const borderRadius = props.borderRadius || (props.content && props.content.borderRadius);
    const borderRadiusTop = props.borderRadiusTop || (props.content && props.content.borderRadiusTop);
    const borderRadiusBottom = props.borderRadiusBottom || (props.content && props.content.borderRadiusBottom);
    const contentfulId = props?.contentfulid || (props.content && props.content.contentfulid);

    // Separate media and content items
    const mediaItems = items?.filter(item => item.__typename === "ContentfulMedia") || [];
    const contentItems = items?.filter(item => item.__typename === "ContentfulRichText") || [];
    const linkItems = items?.filter(item => item.__typename === "ContentfulLink") || [];

    const handleCardClick = () => {
        if (contentfulId) {
            navigate(`/${contentfulId}`);
        }
    };

    return (
        <StyledContainer
            backgroundColor={backgroundColor}
            backgroundShadow={backgroundShadow}
            isClickable={!!contentfulId}
            id={contentfulId}
            onClick={handleCardClick}
            className={`card4 flex-1 relative ${linkItems.length > 0 ? ' pb-[94px] lg:pb-[112px]' : 'pb-[24px]'} flex flex-col items-center justify-start px-[24px] py-[24px] ${borderRadius ? ` rounded-all_48` : ''}${borderRadiusTop ? ` rounded-top_48` : ''}${borderRadiusBottom ? ` rounded-bottom_48` : ''}`}
        >
            {mediaItems.length > 0 && (
                <div className="card4__media w-[120px] h-[120px] mb-[16px]">
                    {mediaItems.map(item => (
                        <MapTo key={item.id} items={item} />
                    ))}
                </div>
            )}

            {contentItems.length > 0 && (
                <div className="card4__content  flex items-center flex-col gap-[16px] mb-[20px]">
                    {contentItems.map(item => (
                        <MapTo key={item.id} items={item} />
                    ))}
                </div>
            )}

            {contentItems.length > 0 && (
                <div className="card4__content  flex flex-col absolute bottom-[35px] lg:bottom-[25px]  gap-[16px]">
                    {linkItems.map(item => (
                        <MapTo key={item.id} items={item} />
                    ))}
                </div>
            )}
        </StyledContainer>
    );
};

export default Card4; 